module.exports = "data:application/octet-stream;base64,cHJhZ21hIHNvbGlkaXR5IF4wLjYuMDsKCmltcG9ydCAnQG9wZW56ZXBwZWxpbi9jb250cmFjdHMvYWNjZXNzL093bmFibGUuc29sJzsKCmFic3RyYWN0IGNvbnRyYWN0IExldmVsIGlzIE93bmFibGUgewogIGZ1bmN0aW9uIGNyZWF0ZUluc3RhbmNlKGFkZHJlc3MgX3BsYXllcikgdmlydHVhbCBwdWJsaWMgcGF5YWJsZSByZXR1cm5zIChhZGRyZXNzKTsKICBmdW5jdGlvbiB2YWxpZGF0ZUluc3RhbmNlKGFkZHJlc3MgcGF5YWJsZSBfaW5zdGFuY2UsIGFkZHJlc3MgX3BsYXllcikgdmlydHVhbCBwdWJsaWMgcmV0dXJucyAoYm9vbCk7Cn0K"


//////////////////
// WEBPACK FOOTER
// ./contracts/levels/base/Level.sol
// module id = 1858
// module chunks = 0